<script setup lang="ts">
import type { Rendering } from '~/types/api'

const props = defineProps<{
  rendering: Rendering
}>()

const localePath = useLocalePath()
const { t } = useI18n()

const { getResourceUrl, getImageSrcSet } = useResources()

const srcset = getImageSrcSet(props.rendering.image?.url)
</script>

<template>
  <div class="group w-full">
    <NuxtLink
      :to="
        localePath({
          name: 'slug',
          params: { slug: rendering?.mainProductLine?.urlSlug },
        })
      "
      class="relative m-0 block h-full overflow-hidden"
    >
      <div
        class="absolute z-10 flex h-full w-full flex-col justify-between bg-black bg-opacity-30 p-8 text-white opacity-0 transition-colors transition-opacity duration-300 group-hover:opacity-100"
      >
        <div class="flex h-full flex-col justify-between">
          <h2 class="font-pragmatica-ext mb-4 text-4xl font-bold">
            {{ rendering.title }}
          </h2>
          <div
            class="font-pragmatica-ext text-right text-sm font-bold underline underline-offset-4"
          >
            {{ t('base.lookbook.productLineDetail') }}
          </div>
        </div>
      </div>
      <div
        class="before:content[''] relative z-0 block h-full w-full overflow-hidden bg-neutral-50 p-0 before:block before:pt-[75%]"
      >
        <img
          :src="getResourceUrl(rendering?.image?.url + '/32x32/FIT')"
          alt=""
          title=""
          class="absolute bottom-0 left-0 top-0 z-0 h-full w-full border-0 object-cover blur-lg"
          loading="eager"
          aria-hidden="true"
        />
        <img
          :alt="rendering?.image?.metaAlt ?? undefined"
          :title="rendering?.image?.metaTitle ?? undefined"
          class="absolute bottom-0 left-0 top-0 z-0 h-full w-full border-0 object-cover"
          loading="lazy"
          sizes="(min-width: 768px) 992px, 100vw"
          :srcset="srcset"
          :src="getResourceUrl(rendering?.image?.url + '/640x640/FIT')"
          data-ll-status="loaded"
        />
      </div>
    </NuxtLink>
  </div>
</template>
